import { render, staticRenderFns } from "./HTZJ.vue?vue&type=template&id=035445e3&scoped=true"
import script from "./HTZJ.vue?vue&type=script&lang=js"
export * from "./HTZJ.vue?vue&type=script&lang=js"
import style0 from "./HTZJ.vue?vue&type=style&index=0&id=035445e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035445e3",
  null
  
)

export default component.exports